import {Box} from '@mui/material';

import usePayment from '../../../hooks/providers/usePayment';
import useReportParameters from '../../../hooks/providers/useReportParameters';
import Parameters from '../parameters/Parameters/Parameters';
import Sources from '../sources/Sources/Sources';
import Updates from '../updates/Updates/Updates';

const ReportParameters = () => {
  const {currentReport} = useReportParameters();
  const numberOfParameters = currentReport?.parameters?.length || 0;

  const {isGuest} = usePayment();

  return (
    <Box
      mt={1.5}
      sx={{
        padding: {
          xs: 1,
          sm: 1.5,
          md: 3
        },
        borderRadius: 2
      }}
    >
      {!isGuest && <Sources />}
      {numberOfParameters > 0 && !isGuest && <Parameters />}

      <Updates />
    </Box>
  );
};

ReportParameters.propTypes = {};

export default ReportParameters;
